export default function LoadingScreen() {
  return (
    <>
      <style>{`
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>

      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src="gear-icon.png"
          alt="Loading"
          style={{
            width: "96px",     
            height: "96px",
            animation: "spin 1.2s linear infinite",
          }}
        />
        <p style={{ marginTop: "1rem", opacity: 0.7, fontSize: "0.9rem" }}>
            Bringing services online this may take a few seconds.        </p>
      </div>
    </>
  );
}
